/**
 * EmptyProjectView Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import LinkButton from '../../../atoms/buttons/LinkButton';
import { IconMusicNote } from '../../../atoms/images/Icon';
import { IconProjectBoxHuge } from '../../../atoms/images/Icon/huge-icons';
import { BrowsePagePath } from '../../browse/Browse';

const classes = new BEM('project-view__empty');

export function EmptyProjectView() {
  return (
    <div {...classes()}>
      <IconProjectBoxHuge {...classes('icon')} />
      <h2 {...classes('title')}>There are no tracks in this playlist.</h2>
      <LinkButton
        to={BrowsePagePath}
        colorScheme="white"
        variant="pill"
        label="Browse Music"
        icon={<IconMusicNote />}
        size="large"
        withShadow
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/projectView/EmptyProjectView.tsx